import { Box, Grid } from '@mui/material';
import { SMSAutoResponse } from 'domains/content/types';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';
import SmsEditor from './SmsEditor';
import SmsPreview from './SmsPreview';
import AutoResponses from './AutoResponses';
import { styles } from '../styles';

type Props = {
    autoResponses?: SMSAutoResponse[];
    content: string;
    editorRef: React.MutableRefObject<any>;
    formattedSmsAutoResponses?: SMSAutoResponse[];
    formattedPreviewContent: string;
    setAutoResponses?: (autoResponses: SMSAutoResponse[]) => void;
    setContent: (content: string) => void;
    setHasInvalidAutoResponses?: (hasInvalidAutoResponses: boolean) => void;
};

const SmsContentWrapper = ({
    autoResponses,
    content,
    editorRef,
    formattedSmsAutoResponses,
    formattedPreviewContent,
    setAutoResponses,
    setContent,
    setHasInvalidAutoResponses,
}: Props) => {
    const { data: featureSettings } = useFeatureSettings();

    const isSmsAutoResponseFeatureEnabled = featureSettings?.sms_auto_response_enabled;

    return (
        <Grid container spacing={3} sx={{ flexGrow: 1 }}>
            <Grid item xs={12} md={6}>
                <Box overflow="auto" paddingBottom={2} paddingRight={4} rowGap={3} sx={styles.container}>
                    <SmsEditor ref={editorRef} content={content} setContent={setContent} />
                    {isSmsAutoResponseFeatureEnabled && (
                        <AutoResponses
                            autoResponses={autoResponses}
                            setAutoResponses={setAutoResponses}
                            setHasInvalidAutoResponses={setHasInvalidAutoResponses}
                        />
                    )}
                </Box>
            </Grid>
            <Grid display="flex" justifyContent="center" item xs={12} md={6}>
                <SmsPreview autoResponses={formattedSmsAutoResponses} formattedContent={formattedPreviewContent} />
            </Grid>
        </Grid>
    );
};

export default SmsContentWrapper;
